import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TopUpProvider } from '../../../../types/types';

const initialState:any ={}

const selectedGiftCardProvider = createSlice({
  name: 'selectedTopUpProvider',
  initialState,
  reducers: {
    setSeletedGiftCardProvider(state,action:PayloadAction<TopUpProvider>){
        return (state = action.payload)
    }
  },

});

// Reducer
export default selectedGiftCardProvider.reducer;

// Actions
export const {setSeletedGiftCardProvider} = selectedGiftCardProvider.actions;

